import { render, staticRenderFns } from "./SundryOrderItemLabelPopUp.vue?vue&type=template&id=48cc12ef&scoped=true&"
import script from "./SundryOrderItemLabelPopUp.vue?vue&type=script&lang=js&"
export * from "./SundryOrderItemLabelPopUp.vue?vue&type=script&lang=js&"
import style0 from "./SundryOrderItemLabelPopUp.vue?vue&type=style&index=0&id=48cc12ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cc12ef",
  null
  
)

export default component.exports